import { getRouteApi } from '@tanstack/react-router';

import type {
    PracticeMemberUsageSortBy,
    PracticeMemberUsageSortDirection,
} from '@/entities/reporting';

const route = getRouteApi('/reporting');

export function useReportingSort(): {
    sortBy: PracticeMemberUsageSortBy;
    sortDirection: PracticeMemberUsageSortDirection;
    toggleSort: (column: PracticeMemberUsageSortBy) => void;
} {
    const { sortBy, sortDirection } = route.useSearch();
    const navigate = route.useNavigate();

    function toggleSort(column: PracticeMemberUsageSortBy) {
        const nextDirection: PracticeMemberUsageSortDirection =
            sortBy === column && sortDirection === 'asc' ? 'desc' : 'asc';
        void navigate({
            search: (prev) => ({ ...prev, sortBy: column, sortDirection: nextDirection }),
            replace: true,
        });
    }

    return { sortBy, sortDirection, toggleSort };
}
